<template>
  <v-container fluid ref="order">
    <v-row>
      <v-col xs12 md8 offset-md2>
        <v-card class="elevation-0">
          <v-card-text class="text-sm-right">
            剩餘來福幣：<span style="font-weight: bold;">{{ $store.getters.user.GoldCount }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col xs12 md8 offset-md2>
        <v-card class="elevation-0">
          <v-toolbar>
            <v-toolbar-title>商品資訊</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <v-col xs12>
                  <v-data-table
                      v-bind:headers="headers"
                      v-model="cart"
                      hide-actions
                      class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.name }}</td>
                      <td class="text-xs-right">{{ props.item.quantity }}</td>
                      <td class="text-xs-right">{{ props.item.cost }}</td>
                    </template>
                  </v-data-table>
                  <div class="text-xs-right mt-3 mr-4">
                    預計扣除來福幣: <span style="font-weight: bold;">{{ total }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!cart[0].isDigital">
      <v-col xs12 md8 offset-md2>
        <v-card class="elevation-0">
          <v-toolbar>
            <v-toolbar-title>寄送資訊</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>姓名</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    name="input-1"
                    label="姓名"
                    v-model="userinfo.Name"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>聯絡地址</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    name="input-2"
                    label="聯絡地址"
                    class="input-group"
                    v-model="userinfo.Address"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>聯絡電話</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    name="input-3"
                    label="聯絡電話"
                    value=""
                    class="input-group"
                    required
                    v-model="userinfo.Phone"
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>配送時間</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-select
                    v-bind:items="[{ text: '無', value: 'None' }, { text: '早上', value: 'Morning' },  { text: '下午', value: 'Afternoon' }, { text: '晚上', value: 'Night' }]"
                    v-model="userinfo.SpecifiedTime"
                    label="配送時間"
                    light
                    single-line
                    auto
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row actions class="mt-4">
      <v-col xs12 style="text-align: center;">
        <v-btn small primary dark v-on:click.native="confirmPurchase()">兌換</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="confirm.purchase" persistent v-if="cart[0]">
      <v-card>
        <v-card-row>
          <v-card-text>確定要兌換 {{ cart[0].name }} ?</v-card-text>
        </v-card-row>
        <v-card-row actions>
          <v-btn class="red--text darken-1" flat="flat" @click.native="confirm.purchase = false">取消</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="purchase()">同意</v-btn>
        </v-card-row>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import api from '../api'

  export default {

    name: 'Order',

    data () {
      return {
        headers: [
          {
            text: '商品資訊',
            sortable: true,
            left: true,
            value: 'name'
          },
          {
            text: '數量',
            sortable: false,
            value: 'quantity'
          },
          {
            text: '需要來福幣',
            sortable: false,
            value: 'cost'
          }
        ],
        userinfo: {
          Name: '',
          Phone: '',
          Address: '',
          SpecifiedTime: 'None' // None,Morning,Afternoon,Night
        },
        confirm: {
          purchase: false
        }
      }
    },

    computed: {
      total () {
        return this.cart.reduce((prev, el) => {
          return prev + el.quantity * el.cost
        }, 0)
      },

      ...mapGetters([
        'cart'
      ])
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '來福幣兌換',
        link: '/order'
      })
    },

    mounted () {
      this.check()
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb',
        'setErrorMessage'
      ]),

      ...mapActions([
        'getProfile'
      ]),

      confirmPurchase () {
        if (this.check()) {
          this.confirm.purchase = true
        }
      },

      purchase () {
        var self = this
        self.confirm.purchase = false
        this.userinfo.SpecifiedTime = this.userinfo.SpecifiedTime.value || 'None'
        api.Exchange.Pay(this.cart[0].id, this.userinfo)
          .then((res) => {
            self.getProfile()
            self.$router.push('/shop')
          })
      },

      check () {
        var errorMsg = ''
        if (this.total > this.$store.getters.user.GoldCount) {
          errorMsg = '來福幣不足！請挑戰更多學習任務累積來福幣。'
        } else if (!this.cart[0].isDigital) {
          if (this.userinfo.Name === '') {
            errorMsg = '請輸入姓名'
          } else if (this.userinfo.Address === '') {
            errorMsg = '請輸入地址'
          } else if (this.userinfo.Phone === '') {
            errorMsg = '請輸入聯絡電話'
          }
        }

        if (errorMsg !== '') {
          this.setErrorMessage(errorMsg)
          window.document.body.scrollTop = 0
          return false
        } else {
          return true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Order.vue?0424f398